export const QUERYSTATUS_TASK = 'query_status_task';
export const QUERYSTATUS_TASK_SUCCESSFUL = 'query_status_task_successfull';
export const QUERYSTATUS_TASK_FAILED = 'query_status_task_failed';



